document.addEventListener('DOMContentLoaded', function () {
  var menuButton = document.querySelector('[data-chatfield-menu]');
  var nav = document.querySelector('[data-chatfield-nav]');
  var desktopNavigation = window.matchMedia('(min-width: 981px)');
  var navigationGroups = document.querySelectorAll('[data-chatfield-nav] .nav-group');

  navigationGroups.forEach(function (group) {
    var summary = group.querySelector('summary');

    group.addEventListener('mouseenter', function () {
      if (desktopNavigation.matches) group.open = true;
    });

    group.addEventListener('mouseleave', function () {
      if (desktopNavigation.matches) group.open = false;
    });

    group.addEventListener('focusin', function () {
      if (desktopNavigation.matches) group.open = true;
    });

    group.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (desktopNavigation.matches && !group.contains(document.activeElement)) group.open = false;
      }, 0);
    });

    if (summary) {
      summary.addEventListener('click', function (event) {
        if (desktopNavigation.matches) event.preventDefault();
      });
    }
  });

  if (menuButton && nav) {
    menuButton.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });
    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        nav.classList.remove('open');
        menuButton.setAttribute('aria-expanded', 'false');
      }
    });
  }

  var carousel = document.querySelector('[data-product-carousel]');

  if (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-product-slide]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-dot]'));
    var previousButton = carousel.querySelector('[data-carousel-prev]');
    var nextButton = carousel.querySelector('[data-carousel-next]');
    var counter = carousel.querySelector('[data-carousel-counter]');
    var activeIndex = 0;
    var frameRequested = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function slideLeft(slide) {
      return slide.offsetLeft - track.offsetLeft;
    }

    function updateCarousel(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      if (counter) {
        counter.textContent = String(activeIndex + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      }
    }

    function goToSlide(index) {
      var wrappedIndex = (index + slides.length) % slides.length;
      track.scrollTo({
        left: slideLeft(slides[wrappedIndex]),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
      updateCarousel(wrappedIndex);
    }

    function syncToScroll() {
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var distance = Math.abs(slideLeft(slide) - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      updateCarousel(closestIndex);
      frameRequested = false;
    }

    track.addEventListener('scroll', function () {
      if (!frameRequested) {
        frameRequested = true;
        window.requestAnimationFrame(syncToScroll);
      }
    }, { passive: true });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goToSlide(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goToSlide(activeIndex + 1);
      }
      if (event.key === 'Home') {
        event.preventDefault();
        goToSlide(0);
      }
      if (event.key === 'End') {
        event.preventDefault();
        goToSlide(slides.length - 1);
      }
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToSlide(Number(dot.getAttribute('data-carousel-dot')));
      });
    });

    if (previousButton) previousButton.addEventListener('click', function () { goToSlide(activeIndex - 1); });
    if (nextButton) nextButton.addEventListener('click', function () { goToSlide(activeIndex + 1); });

    window.addEventListener('resize', function () { goToSlide(activeIndex); });
    updateCarousel(0);
  }
});
